export default __webpack_public_path__ + "static/media/tape_top_and_bottom.4af2c171.png";